import {AuthSlice} from "./AuthSlice";
import {displayAlert} from "./AlertSlice";

// Auth0's own list of errors a user can only recover from by signing in
// interactively, mirrored from auth0-spa-js RECOVERABLE_ERRORS. getAccessTokenSilently
// rejects with a GenericError carrying one of these in `error` once its refresh
// token and iframe fallbacks are exhausted.
const RECOVERABLE_AUTH_ERRORS = [
    'login_required',
    'consent_required',
    'interaction_required',
    'account_selection_required',
    'access_denied',
];

// True when the failure means "this session is no longer usable", as opposed to
// an ordinary API error. A 401 covers the case where Auth0 issued a token but
// the API rejected it. 403 is deliberately excluded: that is a role/permission
// problem for a perfectly valid session, and signing out would be wrong.
export const isSessionError = (error) => {
    if (!error) {
        return false;
    }
    if (RECOVERABLE_AUTH_ERRORS.includes(error.error)) {
        return true;
    }
    return Boolean(error.response) && error.response.status === 401;
};

export const determineIfTokenError = (error) => async (dispatch) => {
    if (isSessionError(error)) {
        dispatch(AuthSlice.actions.sessionExpired());
        dispatch(displayAlert(false, "Your session expired. Please log in again."));
        return;
    }

    // Guarded because this is the error path: it must not throw a second error
    // if it is handed something without a message.
    const message = (error && error.message) || "Something went wrong. Please try again.";
    dispatch(displayAlert(false, message));
}
